import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Icons } from '../../../utilities';
import Inspiration from './Inspiration/Inspiration';
import { connect } from 'react-redux';
import * as actions from '../../../redux/sideBarActions';
import * as Constants from '../../../utilities/constants/Constants';
import { bindActionCreators } from 'redux';
import { string } from '../../../localization';
import './Templates.scss';
import LoadMoreContentsTemplate from '../../../components/LoadingTemplate/LoadMoreContentsTemplate';

const Templates = props => {
  const {
    activeTab,
    inspirationCategory,
    dispatchers,
    selectedInspirationCategory,
    moreImagesLoadingIndicator,
    language,
    templatePreference
  } = props;

  const templatesOptions = [
    {
      name: string.INSPIRATION_KEY,
      alt_text: 'inspiration-icon',
      tab_id: Constants.inspirationsTab,
      img_url: Icons.inspiration,
      slected_img_url: Icons.inspiration
    }
  ];

  const covidInspirations = inspirationCategory.filter(
    inspirationFilter =>
      inspirationFilter.category === Constants.covidInspirationCategory
  );
  if (
    covidInspirations.length > 0 &&
    templatePreference.toLowerCase() != 'psp'
  ) {
    const languageDict = covidInspirations[0].loc_names;
    const covidLabel = languageDict && languageDict[language];
    templatesOptions.push({
      name: covidLabel,
      alt_text: 'covid-icon',
      tab_id: Constants.covidInspirationCategory,
      img_url: Icons.covidDefaultIcon,
      slected_img_url: Icons.covidSelectedIcon
    });
  }

  return (
    <div id='templates'>
      <Nav pills horizontal='true' className='text-white'>
        {templatesOptions.map(option => (
          <NavItem key={option.alt_text}>
            <NavLink
              className={classnames({ active: true })}
              onClick={() => {
                if (option.tab_id != Constants.inspirationsTab) {
                  dispatchers.templatesTabItemIsSelected(option.tab_id);
                }
              }}
            >
              <div className=' d-flex '>
                <div className='icon-wrapper-horizontal '>
                  <img
                    alt={option.alt_text}
                    src={
                      selectedInspirationCategory === option.tab_id
                        ? option.slected_img_url
                        : option.img_url
                    }
                  />
                </div>
              </div>
              <div className='tab-lable-container'>{option.name}</div>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={Constants.inspirationsTab}>
          <div className='load-position'>
            <Inspiration />
            {moreImagesLoadingIndicator ? <LoadMoreContentsTemplate /> : null}
          </div>
        </TabPane>
      </TabContent>

      {/* </div> */}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeTemplatesTab,
    templatePreference: state.modal.storeData.templatePreference,
    moreImagesLoadingIndicator: state.sideBar.showLoading,
    language: state.home.language,
    inspirationCategory: state.sideBar.inspirationCategory,
    selectedInspirationCategory: state.sideBar.inspirations.category
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Templates);
